import { useId } from "react";

export function Logo({ size = 22 }: { size?: number }) {
  // Dock mark: three berths on a quay, on the brand gradient.
  const id = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden className="shrink-0 drop-shadow-[0_2px_6px_var(--hd-ring)]">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          {/* Apps may re-tint the mark with --hd-logo-1/2/3; the defaults are the violet brand. */}
          <stop offset="0%" style={{ stopColor: "var(--hd-logo-1, #8b5cf6)" }} />
          <stop offset="55%" style={{ stopColor: "var(--hd-logo-2, #6d28d9)" }} />
          <stop offset="100%" style={{ stopColor: "var(--hd-logo-3, #4f46e5)" }} />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="22" height="22" rx="6.5" fill={`url(#${id})`} />
      <rect x="5.5" y="6" width="3" height="8" rx="1" fill="#fff" />
      <rect x="10.5" y="6" width="3" height="8" rx="1" fill="#fff" opacity="0.85" />
      <rect x="15.5" y="6" width="3" height="8" rx="1" fill="#fff" opacity="0.7" />
      <rect x="4.5" y="16" width="15" height="2.2" rx="1.1" fill="#fff" />
    </svg>
  );
}
